import * as React from 'react';
import styled from 'styled-components';
import {IBtnDefaultProps, mixinBtnCorporate, mixinBtnMiddle, mixinResetBtnCss, mixinWithBtnPropsFn} from "./btn_mixin";
import {Link, LinkProps} from "react-router-dom";

interface IProps
    extends IBtnDefaultProps, LinkProps {
}

const BtnLinkCorporateMiddleDefault: React.FC<IProps> = (props) => {

    const {icon, widthSize, ...ButtonProps} = props;

    return (<Link {...ButtonProps} />)

};

const BtnLinkCorporateMiddle = styled(BtnLinkCorporateMiddleDefault)`
    ${mixinResetBtnCss}
    ${mixinBtnMiddle}
    ${mixinBtnCorporate}

    ${props => mixinWithBtnPropsFn(props)}
`;

export default BtnLinkCorporateMiddle;

interface ExternalBtnProps extends IBtnDefaultProps {
    href: string;
    target?: string;
}

const ExternalBtnDefault: React.FC<ExternalBtnProps> = (props) => {

    const {...ButtonProps} = props;

    return (<a {...ButtonProps} />)

};

export const ExternalBtn = styled(ExternalBtnDefault)`
    ${mixinResetBtnCss}
    ${mixinBtnMiddle}
    ${mixinBtnCorporate}

    ${props => mixinWithBtnPropsFn(props)}
`;


// WEBPACK FOOTER //
// ./src/presentation/common/atom/btn/btn_link_corporate_middle.tsx